import { PayloadAction } from '../../../../store.model';
import { filterSummaryByKeyword } from '../function/filter-summary-by-keyword.function';
import { ActionType } from '../teamschat-summary.action';
import { TeamschatSummaryState } from '../teamschat-summary.state';

import { FilterSummary } from './filter-summary.action';

export function filterSummaryReducer(
    state: TeamschatSummaryState,
    action: PayloadAction<ActionType, FilterSummary>,
): TeamschatSummaryState {
    try {
        const nextFiltered = filterSummaryByKeyword(
            action.payload.keyword ?? '',
            state.chatSummary,
        );

        return {
            ...state,
            filteredChatSummary: nextFiltered,
            keyword: action.payload.keyword ?? '',
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
